const QUARTER_API_MAP = {
  Q1: "q1",
  Q2: "q2",
  Q3: "q3",
  Q4: "q4",
  YEARLY: "yearly",
};

export const toApiQuarter = (quarterValue) => {
  if (!quarterValue) return "";
  return QUARTER_API_MAP[quarterValue] || String(quarterValue).toLowerCase();
};

export const getFilenameFromContentDisposition = (disposition) => {
  if (!disposition || typeof disposition !== "string") return null;

  const utf8Match = /filename\*=UTF-8''([^;\n]+)/i.exec(disposition);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      return utf8Match[1].trim();
    }
  }

  const quotedMatch = /filename="([^"]+)"/i.exec(disposition);
  if (quotedMatch?.[1]) return quotedMatch[1].trim();

  const plainMatch = /filename=([^;\n]+)/i.exec(disposition);
  if (plainMatch?.[1]) return plainMatch[1].replace(/"/g, "").trim();

  return null;
};

export const defaultQuarterlyReportFilename = (quarter, year) =>
  `quarterly-report-${quarter}-${year}.xlsx`;

export const parseBlobErrorMessage = async (blob, fallback = "Failed to download report.") => {
  if (!(blob instanceof Blob)) return fallback;
  try {
    const text = await blob.text();
    const json = JSON.parse(text);
    return json.error || json.message || fallback;
  } catch {
    return fallback;
  }
};

export const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const buildYearOptions = () => {
  const current = new Date().getFullYear();
  const years = [];
  for (let year = current - 2; year <= current + 1; year += 1) {
    years.push({ label: String(year), value: String(year) });
  }
  return years.reverse();
};

export const currentYearOption = () => {
  const year = String(new Date().getFullYear());
  return { label: year, value: year };
};
